<div>
  <mat-progress-bar *ngIf="loading" color="primary" mode="indeterminate"> </mat-progress-bar>
  <router-outlet></router-outlet>
  <upload-progress-overlay></upload-progress-overlay>
</div>
